/**
 * Copyright © 2026 Adnuntius AS.
 */
export interface CustomEventConversionType {
  value: string | null;
  label: string;
  desc: string;
}

export const CUSTOM_EVENT_CONVERSION_TYPES: CustomEventConversionType[] = [
  { value: null, label: 'Not Applicable', desc: 'This event is not used to track conversions' },
  { value: 'IMPRESSION', label: 'Impression', desc: 'Used to record conversion events after a user was served an impression' },
  { value: 'IMPRESSION_ONE_DAY', label: 'Impression (within 1 day)', desc: 'Used to record conversion events less than one DAY after a user was served an impression' },
  { value: 'IMPRESSION_ONE_WEEK', label: 'Impression (within 1 week)', desc: 'Used to record conversion events less than one WEEK after a user was served an impression' },
  { value: 'IMPRESSION_TWO_WEEKS', label: 'Impression (within 2 weeks)', desc: 'Used to record conversion events less than TWO WEEKS after a user was served an impression' },
  { value: 'IMPRESSION_THIRTY_DAYS', label: 'Impression (within 30 days)', desc: 'Used to record conversion events less than THIRTY DAYS after a user was served an impression' },
  { value: 'CLICK', label: 'Click', desc: 'Used to record conversion events after a user clicked an ad' },
  { value: 'CLICK_ONE_DAY', label: 'Click (within 1 day)', desc: 'Used to record conversion events less than one DAY after a user clicked an ad' },
  { value: 'CLICK_ONE_WEEK', label: 'Click (within 1 week)', desc: 'Used to record conversion events less than one WEEK after a user clicked an ad' },
  { value: 'CLICK_TWO_WEEKS', label: 'Click (within 2 weeks)', desc: 'Used to record conversion events less than TWO WEEKS after a user clicked an ad' },
  { value: 'CLICK_THIRTY_DAYS', label: 'Click (within 30 days)', desc: 'Used to record conversion events less than THIRTY DAYS after a user clicked an ad' }
];

export function findConversionTypeDescription(conversionType: string | null): string {
  const match = CUSTOM_EVENT_CONVERSION_TYPES.find((type) => type.value === conversionType);
  return match ? match.desc : '';
}

export function buildCustomEventExampleCodes(eventId: string) {
  return {
    exampleCode: `adn.inIframe.sendCustomEvent('{{adId}}', {customType: '${eventId}'});`,
    exampleCodeWithCustomValue: `adn.inIframe.sendCustomEvent('{{adId}}', {customType: '${eventId}', customValue: 2});`,
    exampleCodeWithMultipleEvents: `adn.inIframe.sendCustomEvent('{{adId}}', {events:[{customType: '${eventId}', customValue: 2}, {customType: 'another_custom_event_id'}]});`
  };
}
